import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Grid, Modal, Box } from "@mui/material";
import TabComponent from "../../../Tab";
import Tables from "../../../controls/Tables";
import EPriscriptions from "../../EPriscriptions";
import strings from "../../../../constant/strings";
import HeadingComponent from "../../HeadingComponent";
import PatientInformation from "./PatientInformation";
import PreviousAppointments from "./PreviousAppointments";
import PatientDashboard from "../../Patient/PatientDashboard";
import PersonalMedicalDetails from "../../PersonalMedicalDetails";
import { useStyles } from "../../../../assets/styles/PatientDashboardStyles";
import SearchFields from "../../../../pages/PatientPanel/PatientAppointments/SearchFields";
import MedicalReports from "../../MedicalReports";
import { confirmAppointmentAction, getDoctorAppointmentAction, getPatientDetailsForDoctorAction, getPatientPreviousAppointmentForDoctorAction } from "../../../../redux/appointment/doctor/doctorAppointmentActions";
import { getMedicalHistoryAction, getPatientEprescriptionAction, getPatientMedicalReportAction } from "../../../../redux/user/userActions";
import SendMedication from "./SendMedication";
import { commonMuiStyles } from "../../../../assets/styles/CommonMUIStyles";
import { LoadingContainer, NoDetailsContainer, modalStyle } from "../../../../assets/styles/CommonStyles";
import { appointmentOpdListTab0, appointmentOpdListTab1_2, appointmentOpdListTab3, appointmentOpdListTab4, appointmentOpdListUnfinished, appointmentOpdListUnfinishedDoctor, threeTabs } from "../../../../constant/staticLists";
import * as mainService from "../../../../../src/services/mainService";
import { toast } from "react-toastify";
import Sendprescription from "./sendprescription";
import SendMedicationIntegrated from "./SendMedicationNew";

import Timeline from "./Timeline";
import { Pagination, PaginationItem } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Appointments = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const styleClasses = commonMuiStyles();
  const [tabValue, setTabValue] = useState(0);
  const [selectedListItem, setSelectedListItem] = useState("");
  const [appointmentType, setAppointmentType] = useState(0);
  const [appointmentList, setAppointmentList] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(7); // You can adjust this as needed
  const [openModal, setOpenModal] = useState(false);
  const [confirmCompleteModal, setConfirmCompleteModal] = useState(false);
  const [pendingCompleteItem, setPendingCompleteItem] = useState(null);

  const { userData, doctorAppointmentList, loading, medicalHistory } = useSelector((state) => ({
    userData: state.auth.userData,
    doctorAppointmentList: state.doctorAppointment.doctorAppointmentList,
    loading: state.doctorAppointment.loading,
    medicalHistory: state.user.medicalHistory
  }));

  useEffect(() => {
    const getDoctorAppointments = (status) => {
      dispatch(getDoctorAppointmentAction({ token: userData.token, status: status }));
    };
    switch (tabValue) {
      case 0:
        getDoctorAppointments(1);
        break;
      case 1:
        getDoctorAppointments(1);
        break;
      case 2:
        getDoctorAppointments(4);
        break;
      case 3:
        getDoctorAppointments(2);
        break;
      case 4:
        getDoctorAppointments(1); // Unfinished: fetch status=1, filter expired client-side
        break;
      default:
        break;
    }
  }, [tabValue, dispatch, userData.token]);

  useEffect(() => {
    if (doctorAppointmentList === undefined || doctorAppointmentList.length === 0) {
      setAppointmentList([]);
      return;
    }
    const formattedData = doctorAppointmentList.map((item) => ({
      ...item,
      start_time: moment(item.start_time).format("YYYY-MM-DDTHH:mm"),
      end_time: moment(item.end_time).add(1, "seconds").format("YYYY-MM-DDTHH:mm"),
    }));
    const now = new Date();
    const isExpired = (item) => new Date(item.end_time || item.start_time) < now;
    let filteredData = [];
    if (tabValue === 0) {
      const today = moment().startOf("day");
      filteredData = formattedData.filter((item) => moment(item.start_time).isSame(today, "day") && !isExpired(item));
    } else if (tabValue === 1) {
      const todayDate = moment().format("YYYY-MM-DD");
      filteredData = formattedData.filter((item) => moment(item.start_time).isAfter(todayDate, "day") && !isExpired(item));
    } else if (tabValue === 4) {
      // Unfinished: status=1 appointments whose time has passed
      filteredData = formattedData.filter((item) => isExpired(item));
    } else {
      filteredData = formattedData;
    }

    setAppointmentList(filteredData);
  }, [doctorAppointmentList, tabValue]);

  useEffect(() => {
    setPage(1); // Reset page number on list change
  }, [appointmentList]);

  const handleTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleValue = (value) => {
    const matchingEntries = appointmentList?.filter((entry) => entry.patientInfo.name.toLowerCase().includes(value));
    setAppointmentList(matchingEntries);
    if (value === "") {
      setAppointmentList(doctorAppointmentList);
    }
  };

  const handleAppointmentTab = (event, newValue) => {
    setAppointmentType(newValue);
    const todayDate = selectedListItem ? moment(selectedListItem.start_time).utc().format("YYYY-MM-DD") : "";
    const value = {
      token: userData.token,
      appointmentId: selectedListItem?._id,
      date: todayDate,
    };
    const value1 = {
      token: userData.token, id: selectedListItem._id
    };
    const getValue = () => {
      dispatch(getPatientEprescriptionAction(value));
      dispatch(getPatientMedicalReportAction(value));
    };
    if (newValue !== 1 && newValue !== 2) {
      newValue === 0 ? dispatch(getPatientDetailsForDoctorAction(value1)) :
          newValue === 3 ? dispatch(getMedicalHistoryAction(value)) : 
            newValue === 4 ? getValue() :
              dispatch(getPatientPreviousAppointmentForDoctorAction(value));
    }
  };

  const selectedItem = (item) => {
    if (item._id !== selectedListItem._id) {
      setAppointmentType(0);
    }
    if (appointmentType === 0) {
      dispatch(
        getPatientDetailsForDoctorAction({
          token: userData.token,
          id: item._id,
        })
      );
    }
    setSelectedListItem(item);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const onmedicationClick = (openModal, item) => {
    setOpenModal(!openModal);
    setSelectedListItem(item);
  };

  const appointmentDecision = async (item, bool) => {
    const data = { appointmentId: item._id, appointmentAccepted: bool, deleteSlot: false };
    const res = await mainService.confirmAppointmentApi({ token: userData.token, data });
    if (res.response_type === "fail") {
      // toast.error(res?.response?.message, { position: "bottom-center", closeButton: false })
    } else {
      // toast.success(res?.response?.message, { position: "bottom-center", closeButton: false })
      dispatch(getDoctorAppointmentAction({ token: userData.token, status: 0 }));
    }
  };

  const renderAppointmentType = () => {
    switch (appointmentType) {
      case 0:
        return <PatientInformation item={selectedListItem} />;
      case 1:
        return <PatientDashboard navigate="doctor" item={selectedListItem} />;
      case 2:
        return <Timeline appointmentId={selectedListItem?._id} />;
      case 3:
        return <PersonalMedicalDetails navigate="doctor" item={selectedListItem} />;
      case 4:
        return (
          <>
            <MedicalReports navigate="doctor" />
            <EPriscriptions navigate="doctor" />
          </>
        );
      default:
        return <PreviousAppointments />;
    }
  };

  // Calculate the start and end index for pagination
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedList = appointmentList.slice(startIndex, endIndex);


const handlePrescriptionSuccess = () => {
  setOpenModal(false);
};

  const handleCompleteAppointment = (item) => {
    setPendingCompleteItem(item);
    setConfirmCompleteModal(true);
  };

  const handleConfirmComplete = async () => {
    setConfirmCompleteModal(false);
    const res = await mainService.completeAppointmentApi({
      token: userData.token,
      data: { appointmentId: pendingCompleteItem._id }
    });
    setPendingCompleteItem(null);
    if (res.response_type === "fail") {
      toast.error(res?.response?.message || "Failed to complete appointment", { position: "bottom-center", closeButton: false });
    } else {
      toast.success(res?.response?.message || "Appointment completed", { position: "bottom-center", closeButton: false });
      dispatch(getDoctorAppointmentAction({ token: userData.token, status: 1 }));
    }
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} className={classes.mainCont}>
        <HeadingComponent
          text={{
            primary: strings.appointmentsOpd,
            secondary: strings.appointmentOpdHeading,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={8}>
            <TabComponent
              tabs={threeTabs}
              tabValue={tabValue}
              setTabValue={setTabValue}
              handleTab={handleTab}
              customTab={styleClasses.customTab}
              customTabIndicator={styleClasses.customTabIndicator}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SearchFields
              pr={"16px"}
              handleValue={handleValue}
              placeholder={strings.searchByPatientName}
            />
          </Grid>
          <Grid item xs={12}>
            {loading ? <LoadingContainer>{strings.loading}</LoadingContainer> : !!paginatedList && paginatedList.length > 0 ? (
              <>
                <Tables
                  data={paginatedList}
                  fieldsOrder={
                    tabValue === 0 || tabValue === 1
                      ? { ...appointmentOpdListTab1_2, button: 'Chat' }
                      : tabValue === 2
                      ? { ...appointmentOpdListTab3, button: 'Chat' }
                      : tabValue === 4
                      ? appointmentOpdListUnfinishedDoctor
                      : { ...appointmentOpdListTab4, button: 'Chat' }
                  }
                  tabValue={appointmentType}
                  setTabValue={setAppointmentType}
                  handleTab={handleAppointmentTab}
                  selectedItem={selectedItem}
                  openModal={openModal}
                  onmedicationClick={onmedicationClick}
                  onTab={tabValue}
                  appointmentDecision={appointmentDecision}
                  onCompleteAppointment={(tabValue === 0 || tabValue === 1 || tabValue === 4) ? handleCompleteAppointment : undefined}
                >
                  <>{renderAppointmentType()}</>
                </Tables>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                  <Pagination
                    count={Math.ceil(appointmentList.length / rowsPerPage)}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    )}
                  />
                </div>
              </>
            ) : (
              <NoDetailsContainer>No appointments available</NoDetailsContainer>
            )}
          </Grid>
        </Grid>
      </Grid>
<Dialog
  open={openModal}
  onClose={handleClose}
  fullWidth={true}
  maxWidth="lg" // Makes it wide (large) but not full screen
  aria-labelledby="prescription-dialog-title"
  PaperProps={{
    style: { 
      borderRadius: 15, // Nice rounded corners
      minHeight: '80vh' // Ensures it has good height
    },
  }}
>
  {/* Standard Header matching your App's style */}
  <DialogTitle 
    id="prescription-dialog-title" 
    sx={{ 
      display: "flex", 
      justifyContent: "space-between", 
      alignItems: "center",
      backgroundColor: "#f8f9fa", // Light grey header background
      borderBottom: "1px solid #eee",
      padding: "16px 24px"
    }}
  >
    <span style={{ fontWeight: 600, color: "#333" }}>
      Prescription Builder
    </span>
    <IconButton onClick={handleClose} size="small">
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent sx={{ padding: "0px" }}> {/* Remove default padding to let child control it */}
    <SendMedicationIntegrated
      selectedListItem={selectedListItem}
      onSuccess={handlePrescriptionSuccess}
      // Pass a prop to tell the child it's inside a dialog
      isDialog={true} 
    />
  </DialogContent>
</Dialog>

      <Dialog
        open={confirmCompleteModal}
        onClose={() => setConfirmCompleteModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: 12, padding: "8px" } }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
          <span style={{ fontWeight: 600, color: "#333", fontSize: 16 }}>Complete Appointment</span>
          <IconButton onClick={() => setConfirmCompleteModal(false)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p style={{ margin: 0, color: "#555", fontSize: 14 }}>
            Are you sure you want to complete this appointment without sending a prescription?
          </p>
        </DialogContent>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "12px 24px 16px" }}>
          <button
            onClick={() => setConfirmCompleteModal(false)}
            style={{
              padding: "7px 20px", borderRadius: 8, border: "1px solid #ccc",
              background: "#fff", cursor: "pointer", fontSize: 13, color: "#555"
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmComplete}
            style={{
              padding: "7px 20px", borderRadius: 8, border: "none",
              background: "linear-gradient(90deg, #097eb7 0%, #2aab6c 100%)",
              color: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600
            }}
          >
            Yes, Complete
          </button>
        </div>
      </Dialog>
    </Grid>
  );
};

export default Appointments;
